export default "__VITE_ASSET__0af1360c__"